/* eslint-disable @typescript-eslint/naming-convention */
import { useState, useMemo, useEffect, useRef } from 'react';
import { TOPGAMENUM } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import { TableSelectionType } from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import { handleTableDefaultSelectGames } from '@/pages/intelligence/utils/tableUtils';
import type {
  Game,
  UseTopChartsConfig,
  PageSortType,
} from '@intelligence/pages/TopCharts/PCGames/_config/type';
import type { IStoreRankDetailsRankTrendParams } from '@/pages/intelligence/types/storeRank';
// import { getCommonTimeFilterReqValues } from '@/pages/intelligence/utils/common';
import { getMarketKeyList } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/StoreRank/utils';
import { isValidDate } from '@intelligence/utils/filterUtils';
import { componentDefault } from '@intelligence/components/Filter/FilterBase/FilterList';
import { toDateTypeFilter } from '@/pages/intelligence/utils/common';
import moment from 'moment';

// RankTrend获取数据与接口交互的hooks
const useRankTrendModel = (props: UseTopChartsConfig) => {
  const {
    getTableApiFun,
    rankType,
    updateEarliestDateData,
    entityType,
    marketsValue,
    storerankMetricsListValueCur,
    defaultParams,
    metricSelectedDefaultObjCur,
  } = props || {};

  const [fetchParams, setFetchParams] = useState<IStoreRankDetailsRankTrendParams>({
    ...defaultParams,
    entity_type: entityType,
    app_ids: [''],
    source: storerankMetricsListValueCur,
    regions: marketsValue,
  });
  // 宽表总数据条数
  const [tableTotal, setTableTotal] = useState(0);
  // 宽表数据
  const [tableData, setTableData] = useState<any>([]);
  // 宽表缓存数据
  const [cacheTableData, setCacheTableData] = useState<any>([]);
  // echarts图表类d
  // 折线图数据源
  const [lineData, setLineData] = useState<any>([]);
  // 宽表勾选的数据
  const [defaultSelectionGames, setDefaultSelectionGames] = useState<TableSelectionType[]>([]);
  const [tableSelection, setTableSelection] = useState<TableSelectionType[]>([]);
  // 宽表数据-Market Count
  const [tableDataMarket, setTableDataMarket] = useState<any>([]);
  // 折线图数据源-Market Count
  // const [lineDataMarket, setLineDataMarket] = useState<any>([]);
  // Market Count宽表下钻数据
  // const [lineDataMarket, setLineDataMarket] = useState<any>([]);

  const sortMetric = useMemo(() => {
    return metricSelectedDefaultObjCur?.value;
  }, [metricSelectedDefaultObjCur]);

  const sourceValue = useMemo(() => {
    return metricSelectedDefaultObjCur?.dataSource;
  }, [metricSelectedDefaultObjCur]);

  const [pageSortAttr, setPageSortAttr] = useState<PageSortType>({
    currentSortValue: 'desc',
    currentSortMetric: sortMetric,
    currentRatioType: 0,
    sortKey: `${sortMetric}_${sourceValue}_0`,
  });

  // 是否重新操作过复选器提交
  const [isNewComfirm, setIsNewComfirm] = useState(true);
  // 是否重新勾选过游戏
  const [isNewCheckGame, setIsNewCheckGame] = useState(true);
  /** 真正的是否重新勾选游戏， 上面那个isNewCheckGame需要做优化处理 */
  const [operatedGame, setOperatedGame] = useState(false);
  const [showNoGameExtendModal, setShowNoGameExtendModal] = useState(false);
  const [trendLoading, setTrendLoading] = useState(true);
  const [trendError, setTrendError] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  // 是否进行了宽表的check操作
  const [isOperateCheckox, setIsOperateCheckbox] = useState<boolean>(false);
  const [tableSearchValue, setTableSearchValue] = useState('');
  const [reqDateObject, setReqDateObject] = useState({});
  const curRef = useRef({ last: true, radio: false });
  const isOperateRef = useRef(false);
  // 处理点击排序后勾选数据和请求折线的交互
  const updateGetGameData = (list: Game[]) => {
    let newList = [...list];
    updateSelection(newList);
    newList = newList.map((item, index) => ({ ...item, rank: index + 1 }));
    return newList.slice(0);
  };

  const updateSelection = function (sortTable: any[], isNeedLine = false) {
    const filterSelector = sortTable.slice(0, TOPGAMENUM);
    const defaultGames = handleTableDefaultSelectGames(filterSelector, 'market');
    setTimeout(() => {
      setDefaultSelectionGames(defaultGames);
      if (!isOperateRef.current) {
        setTableSelection(defaultGames);
        if (isNeedLine) {
          getLineChartData(getMarketKeyList(defaultGames));
        }
      }
    }, 1);
  };

  useEffect(() => {
    isOperateRef.current = isOperateCheckox;
  }, [isOperateCheckox]);
  const setBoolean = (bLast: boolean, radioDate: boolean) => {
    curRef.current.last = bLast;
    curRef.current.radio = radioDate;
  };

  const getTrendRegions = (pageParamsTemp: any) => {
    if (pageParamsTemp?.isNoNeedTrendRegions === true) {
      return [];
    }
    if (tableSelection?.length > 0 && isOperateCheckox) {
      return tableSelection?.map((item: any) => item.market) || [];
    }
    return [];
  };

  const getCommonTimeFilterReqValues = (dateValue: any, dateType: string, indexKey: any) => {
    if (dateType) {
      const dateValueMoment = isValidDate(dateValue)
        ? dateValue
        : componentDefault[toDateTypeFilter[dateType]][indexKey];
      const dateFormatValue =
        toDateTypeFilter[dateType] === 'month'
          ? `${moment(dateValueMoment).format('YYYY-MM')}-01`
          : moment(dateValueMoment).format('YYYY-MM-DD');
      return dateFormatValue;
    }
    return dateValue;
  };

  const getTableData = async (
    argums: IStoreRankDetailsRankTrendParams,
    ignoreFetchParams = false,
    rankTypeValue = rankType,
  ) => {
    setTableLoading(true);
    setTrendLoading(true);
    const pageParamsTemp = {
      ...argums,
      // unified_id: basicInfo?.id,
      // // 排序指标，默认选择数据源第一个指标
      // order_source: pageSortAttr?.currentSortMetric,
      // order: pageSortAttr?.currentSortValue,
      // ratio_type: pageSortAttr?.currentRatioType,
      // regions: getMarketsValue(argums.regions, regionOptions),
    } as any;

    // 仅当宽表类型为latest_ranking的时候，且仅调用宽表接口的时候，开始时间才为与结束时间同一天
    const pageParams = {
      ...pageParamsTemp,
      trend_regions: getTrendRegions(pageParamsTemp),
      b_ratio_start_date: curRef.current.radio,
      b_last_date: curRef.current.last,
    } as any;

    const isSearch = pageParams?.unified_ids?.length > 0;

    delete pageParams?.platform;
    delete pageParams?.segement;
    delete pageParams?.isNoNeedTrendRegions;
    setFetchParams(pageParams);
    // 无论请不请求接口，都先更新一下参数
    if (!ignoreFetchParams) {
      setIsOperateCheckbox(false);
    }

    // eslint-disable-next-line no-prototype-builtins
    if (pageParams.hasOwnProperty('app_ids') && !pageParams.app_ids?.length) {
      setTableData([]);
      setTableTotal(0);
      if (!isSearch) {
        setLineData([]);
        setTableSelection([]);
      }
      setTableLoading(false);
      if (!isOperateRef.current) {
        setTrendLoading(false);
      }
      return;
    }

    try {
      setTableData([]);
      const resData = await getTableApiFun(pageParams);
      const list = resData?.data?.list || [];
      const trendList = resData?.data?.trends || [];
      const req = resData?.req;
      const {
        end_date,
        start_date,
        link_start_date,
        link_end_date,
        ext_fields = {},
      } = resData?.data || {};
      const { market_count = {} } = ext_fields;
      // 请求接口后需要前端排序
      const newList = updateGetGameData(list);
      setCacheTableData(list);
      setTableData(newList);
      setTableTotal(newList?.length);
      setTableSearchValue('resetSearch');
      setReqDateObject({
        ...{ end_date, start_date, link_start_date, link_end_date },
      });

      let pageParamsValue = pageParams;

      // 仅改变筛选器和默认第一次的时候，需要重新设置起始时间参数
      if (req && !ignoreFetchParams) {
        // 如果数据没有正常返回则不设置
        pageParamsValue = {
          ...pageParamsValue,
          start_date: getCommonTimeFilterReqValues(req?.start_date, req?.granularity, 0),
          end_date: getCommonTimeFilterReqValues(req?.end_date, req?.granularity, 1),
        };
        // 若此时是latest_ranking，则不需要更新时间参数
        // if (rankTypeValue !== 'latest_ranking') {
        setFetchParams(pageParamsValue);
        // }
        const filterSelector = list.slice(0, 6);
        setTableSelection(filterSelector);
      }

      // 如果用户的勾选操作,或者切换宽表segment时,或者在latest改变筛选器的时候，需要调用可视化接口
      // if (isOperateRef.current || ignoreFetchParams || rankTypeValue === 'latest_ranking') {
      //   getLineChartData(pageParamsValue.regions, pageParamsTemp);
      // } else {
      setLineData(trendList);
      // }

      // 如果是Market Count页面，则更新相应数据
      if (pageParamsValue?.ext_fields && pageParamsValue?.ext_fields?.market_count) {
        setTableDataMarket(market_count);
      }

      // 更新最早有数据时间
      updateEarliestDateData({
        entity_type: pageParamsValue.entity_type,
        data_sources: pageParamsValue.source,
        app_ids: pageParamsValue.app_ids,
        metric: ['rank'],
        unified_id: pageParamsValue?.unified_id,
        region_type: pageParamsValue.region_type,
        regions: pageParamsValue.regions,
        dateType: pageParamsValue.granularity,
      });
    } catch (e) {
      console.error(e);
      // 如果是搜索的情况接口报错，不需要清空可视化
      setTableData([]);
      setTableTotal(0);
      if (!isSearch) {
        setLineData([]);
        setTableSelection([]);
      }
    } finally {
      setTableLoading(false);
      setTrendLoading(false);
      // if (!isOperateRef.current) {
      //   setTrendLoading(false);
      // }
    }
  };

  // 可视化请求接口函数
  const getLineChartData = async (keyList: string[], fetchParamsValue: any = fetchParams) => {
    // 如果数据没有正常返回则不设置
    const newFetchParams = {
      ...fetchParamsValue,
      trend_regions: keyList || [],
      // trend_market_type: 'manual',
    };
    setFetchParams(newFetchParams);
    if (newFetchParams?.regions?.length > 0) {
      try {
        setTrendLoading(true);
        const res = await getTableApiFun(newFetchParams);
        const data = res?.data?.trends || [];
        setLineData(data || []);
        setIsNewComfirm(false);
        setIsNewCheckGame(false);
      } catch (e) {
        setLineData([]);
        setTrendError(true);
        console.error(e);
      } finally {
        setTrendLoading(false);
      }
    } else {
      // 未勾选任何游戏，不请求，返回为空数据
      setLineData([]);
    }
  };

  return {
    fetchParams,
    tableTotal,
    tableData,
    lineData,
    trendLoading,
    tableLoading,
    trendError,
    defaultSelectionGames,
    isNewComfirm,
    setIsNewComfirm,
    isNewCheckGame,
    setIsNewCheckGame,
    tableSelection,
    operatedGame,
    setOperatedGame,
    setTableSelection,
    showNoGameExtendModal,
    setShowNoGameExtendModal,
    getTableData,
    setFetchParams,
    pageSortAttr,
    tableSearchValue,
    setIsOperateCheckbox,
    getLineChartData,
    reqDateObject,
    setBoolean,
    setTableData,
    setTableSearchValue,
    cacheTableData,
    updateSelection,
    setPageSortAttr,
    tableDataMarket,
  };
};

export default useRankTrendModel;
